// extracted by mini-css-extract-plugin
module.exports = {"chart":"ProductViews_chart__2KMiK"};